import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FiStar } from 'react-icons/fi';

const messages = { predator: 'Predator flagged!', interesting: 'Sighting highlighted!' };
const colors = ['#ff850b', '#ffd166', '#b5d99c', '#fff4cf'];
const confetti = Array.from({ length: 24 }, (_, index) => ({
  '--confetti-x': `${(index - 11.5) * 13}px`,
  '--confetti-y': `${50 + (index % 5) * 14}px`,
  '--confetti-spin': `${(index % 2 ? 1 : -1) * (180 + index * 23)}deg`,
  '--confetti-delay': `${(index % 4) * 25}ms`,
  backgroundColor: colors[index % colors.length],
}));

export function useMotionCelebration() {
  const [celebration, setCelebration] = useState(null);
  const lastRequest = useRef(null);
  const dismissCelebration = useCallback(() => setCelebration(null), []);
  const celebrate = useCallback((answer) => {
    const flag = answer.flags?.predator ? 'predator' : answer.flags?.interesting ? 'interesting' : null;
    if (!flag) { setCelebration(null); return; }
    if (lastRequest.current === answer.requestId) return;
    lastRequest.current = answer.requestId;
    setCelebration({ id: answer.requestId, flag });
  }, []);
  useEffect(() => {
    if (!celebration) return undefined;
    const timer = window.setTimeout(() => setCelebration(null), 1600);
    return () => window.clearTimeout(timer);
  }, [celebration]);
  return { celebration, celebrate, dismissCelebration };
}

export default function MotionCelebration({ celebration }) {
  // Keep the live region mounted, and restart only the small visual burst.
  return <div className="cr-motion-celebration" role="status" aria-live="polite" aria-atomic="true">
    {celebration && <div className="cr-motion-celebration-burst" key={celebration.id}>
      <div className="cr-motion-confetti" aria-hidden="true">{confetti.map((style, index) => <i key={index} style={style} />)}</div>
      <div className="cr-motion-celebration-badge"><FiStar aria-hidden="true" />{messages[celebration.flag]}</div>
    </div>}
  </div>;
}
